import viberChatConfig from './viberChatConfig';
import { AbstractChatProxyListener } from '../websocket/abstractChatProxyListener';
import { SupportedChatChannel } from '../supportedChatChannel';

export default class ViberChatListener extends AbstractChatProxyListener {
  constructor() {
    super(SupportedChatChannel.VIBER, viberChatConfig);
  }
}
